import e from "./InlineCode.module.js";
import { c as t } from "react/compiler-runtime";
import n from "classnames";
import { jsx as r } from "react/jsx-runtime";
import i from "@jetbrains/ring-ui-built/components/code/code";
//#region src/components/InlineCode/InlineCode.tsx
var a = (a) => {
	let o = t(5), { className: s, code: c } = a, l;
	o[0] === s ? l = o[1] : (l = n(s, e.code), o[0] = s, o[1] = l);
	let u;
	return o[2] !== c || o[3] !== l ? (u = /* @__PURE__ */ r(i, {
		inline: !0,
		className: l,
		code: c
	}), o[2] = c, o[3] = l, o[4] = u) : u = o[4], u;
};
//#endregion
export { a as InlineCode };
